import { FormBuilder, FormGroup } from '@angular/forms';

export class FilterForm {
    static build(builder: FormBuilder): FormGroup {
        return builder.group({
            billSearch: [''],
            bill: [null],
            owner: [null],
            requestType: [null],
            requestStatus: [null],
            priority: [null],
            task: [null],
            taskDueStart: [null],
            taskDueEnd: [null],
        });
    }
}

export type FilterField = {
    label: string;
    controlName: string;
    isSelectList?: boolean;
};

export enum FieldType {
    SelectList = 'selectlist',
    MultiList = 'multilist',
}

export enum Control {
    BillSearch = 'billSearch',
    TaskDue = 'TaskDue',
    TaskDueStart = 'TaskDueStart',
    TaskDueEnd = 'TaskDueEnd',
}
